document.addEventListener("DOMContentLoaded", function() {
    const spherificationRatios = {
        direct: { sodiumAlginate: 0.5, calciumChloride: 0.5 },
        reverse: { sodiumAlginate: 0.5, calciumLactate: 1.0 }
    };

    function calculateSpherification() {
        let volumeInput = document.getElementById("volume").value;
        let unit = document.getElementById("unit").value;
        let method = document.getElementById("method").value;
        let liquidType = document.getElementById("liquid-type").value;

        if (!volumeInput || volumeInput <= 0) {
            alert("Please enter a valid batch size.");
            return;
        }

        let volume = unit === "oz" ? volumeInput * 29.5735 : volumeInput; // Convert ounces to ml if needed
        let ratios = spherificationRatios[method];
        let resultText = "<h3>Recommended Spherification Amounts:</h3><ul>";

        for (const [ingredient, percentage] of Object.entries(ratios)) {
            const grams = (volume * percentage) / 100;
            const ounces = grams * 0.035274; // Convert grams to ounces
            resultText += `<li><strong>${ingredient.charAt(0).toUpperCase() + ingredient.slice(1)}</strong>: ${grams.toFixed(2)} grams (${ounces.toFixed(2)} oz)</li>`;
        }
        resultText += "</ul>";

        document.getElementById("result").innerHTML = resultText;
    }

    document.getElementById("spherification-calculator").innerHTML = `
        <div style="padding: 20px; border: 1px solid #ddd; border-radius: 8px; max-width: 400px; margin: auto; background-color: #f9f9f9;">
            <h2 style="text-align: center;">Spherification Ratio Calculator</h2>
            <label>Batch Size:</label>
            <input type="number" id="volume" style="width: 100%; padding: 5px; margin-bottom: 10px;">
            <select id="unit" style="width: 100%; padding: 5px; margin-bottom: 10px;">
                <option value="ml">Milliliters (ml)</option>
                <option value="oz">Ounces (oz)</option>
            </select>
            
            <label>Liquid Type:</label>
            <select id="liquid-type" style="width: 100%; padding: 5px; margin-bottom: 10px;">
                <option value="water">Water-based (juice, broth, coffee)</option>
                <option value="alcohol">Alcohol-based (cocktails, spirits)</option>
                <option value="dairy">Dairy-based (milk, yogurt)</option>
                <option value="fatty">Fatty liquids (oil, chocolate)</option>
            </select>

            <label>Spherification Method:</label>
            <select id="method" style="width: 100%; padding: 5px; margin-bottom: 10px;">
                <option value="direct">Direct Spherification</option>
                <option value="reverse">Reverse Spherification</option>
            </select>

            <button id="calculate-btn" style="width: 100%; padding: 10px; background: #FF7E00; color: white; border: none; border-radius: 5px; cursor: pointer;">
                Calculate
            </button>

            <div id="result" style="text-align: center; font-weight: bold; margin-top: 15px;"></div>
        </div>
    `;

    document.getElementById("calculate-btn").addEventListener("click", calculateSpherification);
});
